import { gql } from '@apollo/client';
/**
 * @fragment ConfigurationFieldFragment
 * @since 1.0.0
 */
export const ConfigurationFieldFragment = gql `
  fragment ConfigurationFieldFragment on ConfigurationField {
    id
    type
    category
    fieldKey
    value
    editable
    media {
      id
      url
    }
    order
    updatedAt
  }
`;
